export var getPrimaryNavLinks = function getPrimaryNavLinks(text) {
  return [{
    parent: {
      text: text[0]
    },
    children: [{
      text: text[1],
      href: 'about'
    }, {
      text: text[2],
      href: 'https://www.chegg.org',
      useAbsolute: true
    }, {
      text: text[3],
      href: 'https://collegemarketing.chegg.com/',
      useAbsolute: true
    }, {
      text: text[4],
      href: 'https://investor.chegg.com/Overview/default.aspx',
      useAbsolute: true
    }, {
      text: text[5],
      href: 'about/working-at-chegg'
    }, {
      text: text[6],
      href: 'affiliate-program'
    }, {
      text: text[7],
      href: 'press'
    }]
  }, {
    parent: {
      text: text[8]
    },
    children: [{
      text: 'Busuu',
      href: 'https://www.busuu.com/',
      useAbsolute: true
    }, {
      text: 'Citation Machine',
      href: 'https://www.citationmachine.net/',
      useAbsolute: true
    }, {
      text: 'EasyBib',
      href: 'https://www.easybib.com/',
      useAbsolute: true
    }, {
      text: 'Mathway',
      href: 'https://www.mathway.com/',
      useAbsolute: true
    }, {
      text: 'Thinkful',
      href: 'https://www.thinkful.com/',
      useAbsolute: true
    }]
  }, {
    parent: {
      text: text[9]
    },
    children: [{
      text: text[10],
      href: 'contactus/feedback'
    }, {
      text: text[11],
      href: 'contactus'
    }, {
      text: text[12],
      href: 'my/orders'
    }]
  }, {
    parent: {
      text: text[13]
    },
    children: [{
      text: text[14],
      href: 'about/academic-integrity'
    }, {
      text: text[15],
      href: 'honorshield'
    }, {
      text: text[16],
      href: 'about/chegg-institute'
    }]
  }];
};
export var getLegalNav = function getLegalNav(text) {
  return [{
    text: text[0],
    href: 'cookienotice',
    useAbsolute: false
  }, {
    text: text[1],
    href: 'https://privacyportal.onetrust.com/webform/a21a74f4-2f93-44a2-a887-302a9213c997/06b040b7-49eb-464a-b19a-ea35c85c79fc',
    useAbsolute: true
  }, {
    text: text[2],
    href: '#',
    useAbsolute: true,
    configuration: {
      ELEMENT_CLASS: 'ot-sdk-show-settings',
      ELEMENT_ID: 'ot-sdk-btn'
    }
  }, {
    text: text[3],
    href: 'generalpolicies',
    useAbsolute: false
  }, {
    text: text[4],
    href: 'privacypolicy',
    useAbsolute: false
  }, {
    text: text[5],
    href: 'honorcode',
    useAbsolute: false
  }, {
    text: text[6],
    href: 'copyright',
    useAbsolute: false
  }];
};
export var getIntlCheggProductsServices = function getIntlCheggProductsServices(text) {
  return {
    parent: {
      text: text[0]
    },
    children: [{
      text: text[1],
      href: 'study'
    }, {
      text: text[2],
      href: 'writing/features/citation-generator'
    }, {
      text: text[3],
      href: 'access-codes'
    }, {
      text: text[4],
      href: 'writing/features/grammar-check'
    }, {
      text: text[5],
      href: 'math-solver'
    }, {
      text: text[6],
      href: 'mobile'
    }, {
      text: text[7],
      href: 'homework-help/solutions-manual'
    }, {
      text: text[8],
      href: 'writing/features/plagiarism-checker'
    }, {
      text: text[9],
      href: 'perks'
    }]
  };
};
export var getUSCheggProductsServices = function getUSCheggProductsServices(text) {
  return {
    parent: {
      text: text[0]
    },
    children: [{
      text: text[1],
      href: 'cheap-textbooks'
    }, {
      text: text[2],
      href: 'study'
    }, {
      text: text[3],
      href: 'writing/features/citation-generator'
    }, {
      text: text[4],
      href: 'college-textbooks'
    }, {
      text: text[5],
      href: 'access-codes'
    }, {
      text: text[6],
      href: 'etextbooks'
    }, {
      text: text[7],
      href: 'writing/features/grammar-check'
    }, {
      text: text[8],
      href: 'math-solver'
    }, {
      text: text[9],
      href: 'mobile'
    }, {
      text: text[10],
      href: 'homework-help/solutions-manual'
    }, {
      text: text[11],
      href: 'writing/features/plagiarism-checker'
    }, {
      text: text[12],
      href: 'textbooks'
    }, {
      text: text[13],
      href: 'used-textbooks'
    }, {
      text: text[14],
      href: 'perks'
    }]
  };
};